const transportationTypes = {
  barge: 'Barge',
  other: 'Other',
  railcar: 'Railcar',
  truck: 'Truck',
  vessel: 'Vessel',
};

export default transportationTypes;
